export default __webpack_public_path__ + "static/media/8.97438562.png";